import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-ea5b4244"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tech-box"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tech-title"
}, "技术信息", -1));
const _hoisted_3 = {
  class: "tech-item tech-item-copy"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "认证地址", -1));
const _hoisted_5 = {
  class: "info"
};
const _hoisted_6 = {
  class: "tech-item tech-item-copy"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "唯一编码", -1));
const _hoisted_8 = {
  class: "info"
};
const _hoisted_9 = {
  class: "tech-item tech-item-copy"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "交易HASH", -1));
const _hoisted_11 = {
  class: "info"
};
const _hoisted_12 = {
  class: "tech-item"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "交易时间", -1));
const _hoisted_14 = {
  class: "info"
};
const _hoisted_15 = {
  class: "tech-item"
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "label"
}, "发行方", -1));
const _hoisted_17 = {
  class: "info"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, _toDisplayString($props.detail.main_id), 1), _createElementVNode("i", {
    onClick: _cache[0] || (_cache[0] = $event => $options.copyActiveCode($event, $props.detail.main_id))
  })]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createElementVNode("div", _hoisted_8, _toDisplayString($props.detail.stock_hash), 1), _createElementVNode("i", {
    onClick: _cache[1] || (_cache[1] = $event => $options.copyActiveCode($event, $props.detail.stock_hash))
  })]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, _toDisplayString($props.detail.tx_hash), 1), $props.detail.tx_hash ? (_openBlock(), _createElementBlock("i", {
    key: 0,
    onClick: _cache[2] || (_cache[2] = $event => $options.copyActiveCode($event, $props.detail.tx_hash))
  })) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, _toDisplayString($props.detail.tx_date), 1)]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("div", _hoisted_17, _toDisplayString($props.detail.issuer), 1)])]);
}